import CommonContainer from "../Container/CommonContainer";
import React, { useState, useRef, useEffect, useCallback } from "react";
import { GetCaseRecordTypeList } from '../../Services/Complaint/ComplaintService';
import * as PartnerCaseService from '../../Services/PartnerCase/PartnerCaseService'
import toast from "react-hot-toast";
import { useForm, useWatch } from 'react-hook-form';
import { store } from "../../Store/store";
import ReactDatePicker from 'react-datepicker';
import { Calendar } from "lucide-react";
import { FaSpinner, FaSearch, FaSyncAlt, FaRegTrashAlt, FaPlusSquare, FaMinusSquare, FaDownload, FaComments } from "react-icons/fa";
import { FileIcons, LoadingMessage, allowedTypes, API_DOMAIN, API_HEADER } from "../../Common/CommonVariables";
import CommonPagination from "../../Common/CommonPagination";
import "./PartnerCaseComponent.css";
import LoadingSpinnerComponent from "../Loader/LoadingSpinnerComponent";
import * as moment from 'moment';
import { trackPromise } from 'react-promise-tracker';
import axios from 'axios'
import { saveAs } from 'file-saver';
import RaiseComplaint from "./RaiseComplaintModalComponent";
import { useRaiseComplaintRights } from "../../Common/CommonAccessFile";

const PartnerCaseComponent = () => {
  const accessToRaiseComplaintRights = useRaiseComplaintRights();

  const [complaintTypeShow, setComplaintTypeShow] = useState(false);
  const [CaseRecordTypeDetialList, setCaseRecordTypeDetialList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedComplaintType, setSelectedComplaintType] = useState(null);
  const [selectedComplaintTypeID, setSelectedComplaintTypeID] = useState(null);
  const [caseCreationModalShow, setCaseCreationModalShow] = useState(false);

  //-----
  const [showRaiseComplaintModal, setShowRaiseComplaintModal] = useState(false)

  const [filteredPartnerComplaintList, setFilteredPartnerComplaintList] = useState([]);
  // const [contactDetails, setContactDetails] = useState([]);
  const [activeTab, setActiveTab] = useState('caseInfo');

  //upload document hooks/ref
  const fileInputRef = useRef(null);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [UploadedFileAttachmentList, setUploadedFileAttachmentList] = useState([]);

  //VID dd hooks
  const [inputValue, setInputValue] = useState("");
  const [options, setOptions] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const debounceRef = useRef(null);

  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [SearchLoading, setSearchLoading] = useState(false);
  const startDateRef = useRef(null);
  const endDateRef = useRef(null);
  const selectedSearchCN = useRef();

  //case description dd hooks
  const [caseCategoryList, setCaseCategoryList] = useState([]);
  const [srTypeList, setSrTypeList] = useState([]);
  const [srSubTypeList, setSrSubTypeList] = useState([]);
  const [dateRangeOption, setDateRangeOption] = useState('Today');

  // Pagination Code
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10); // Set number of items per page

  const indexOfLastRow = currentPage * itemsPerPage;
  const indexOfFirstRow = indexOfLastRow - itemsPerPage;
  const currentList = filteredPartnerComplaintList.slice(indexOfFirstRow, indexOfLastRow);

  //Case Details/History states
  const [expandedSections, setExpandedSections] = useState({
    caseDetails: true,
    customerDetails: true,
    status: true,
    actionTaken: true,
  });
  const [selectedCase, setSelectedCase] = useState({});
  const [caseDetailModal, setCaseDetailModal] = useState(false);
  const [caseAttachmentDetails, setcaseAttachmentDetails] = useState(null); //Tab2
  const [caseCommentDetails, setcaseCommentDetails] = useState(null); //Tab3
  const [caseHistoryDetails, setcaseHistoryDetails] = useState(null); // Tab 4
  const [caseViewActiveTab, setCaseViewActiveTab] = useState("caseDetails");
  const [showFullDescription, setShowFullDescription] = useState(false);
  const [CaseLocationDetailsList, setCaseLocationDetailsList] = useState([]);
  const [CaseStageDetailsList, setCaseStageDetailsList] = useState([]);
  const [CaseSRTypeDetailsList, setCaseSRTypeDetailsList] = useState([]);
  const [CaseSRSubTypeDetailsList, setCaseSRSubTypeDetailsList] = useState([]);
  const [CaseCategoryDetailsList, setCaseCategoryDetailsList] = useState([]);

  const { register, handleSubmit, formState: { errors }, reset, setValue, watch, trigger, register: registerEditCase, formState: { errors: errorEditCase } } = useForm({
    defaultValues: {
      level: undefined,
    },
  });

  const level = watch("level");

  const partnerInfo = store.getState();

  const handleDateRangeChange = (e) => {
    const selected = e.target.value;
    setDateRangeOption(selected);

    const today = new Date();
    let start = null;
    let end = null;

    switch (selected) {
      case 'Today':
        start = new Date();
        end = new Date();
        break;
      case 'Yesterday':
        start = new Date();
        start.setDate(start.getDate() - 1);
        end = new Date(start);
        break;
      case 'Current Week':
        start = new Date();
        start.setDate(start.getDate() - start.getDay());
        end = new Date();
        break;
      case 'Last 7 Days':
        start = new Date();
        start.setDate(start.getDate() - 6);
        end = new Date();
        break;
      case 'MTD':
        start = new Date(today.getFullYear(), today.getMonth(), 1);
        end = new Date();
        break;
      case 'Last 30 Days':
        start = new Date();
        start.setDate(start.getDate() - 29);
        end = new Date();
        break;
      case 'Custom':
        start = null;
        end = null;
        break;
      default:
        break;
    }

    setStartDate(start);
    setEndDate(end);
  };

  useEffect(() => {
    if (dateRangeOption != "Custom") {
      fetchPartnerComplaints();
    }
  }, [dateRangeOption]);

  const handleFileChange = (event) => {
    const maxFiles = 5;
    const file = event.target.files;
    const maxFileSize = 5 * 1024 * 1024; // 5MB

    if (!file || file.length === 0) {
      if (fileInputRef.current) {
        fileInputRef.current.value = null;
      }
      return;
    }

    if (file) {
      if (!allowedTypes.includes(file[0].type) || file[0].size > maxFileSize) {
        toast.error('File is either unsupported or exceeds the 5MB limit.');
        if (fileInputRef.current) {
          fileInputRef.current.value = null;
        }
        return;
      }

      if (selectedFiles.length >= maxFiles) {
        toast.error(`You can only upload up to ${maxFiles} files.`);
        if (fileInputRef.current) {
          fileInputRef.current.value = null;
        }
        return;
      }

      const alreadyExists = selectedFiles.some(f => f.name === file[0].name && f.size === file[0].size);
      if (alreadyExists) {
        toast.error('This file is already selected.');
        if (fileInputRef.current) {
          fileInputRef.current.value = null;
        }
        return;
      }
      const filesArray = Array.from(event.target.files);

      // You can add logic here to determine which section/document to update
      setSelectedFiles(prevFiles => [...prevFiles, ...filesArray]);
    }
  };

  const handleFileUpload = () => {
    setLoading(true);
    const formData = new FormData();


    const uploadedTitles = UploadedFileAttachmentList.map(file => file.Title);
    const newFilesToPush = selectedFiles.filter(file => !uploadedTitles.includes(file.name));

    newFilesToPush.forEach(file => {
      formData.append('Myfile', file)
    });

    if (newFilesToPush.length <= 0) {
      toast.error("Please select file first!")
      setLoading(false);
      return
    }
    PartnerCaseService.UploadMultiplePartner_SalesForce_Document(formData)
      .then(({ data }) => {
        if (data.IsSuccess) {
          if (fileInputRef.current) {
            fileInputRef.current.value = null;
          }
          setUploadedFileAttachmentList(prevList => [...prevList, ...data.Data]);
          toast.success(data.Data.length + " files uploaded successfully.")
        } else {
          // setUploadedFileAttachmentList([])
        }
      })
      .catch(() => toast.error("Something went wrong."))
      .finally(() => setLoading(false));
  }

  const handleInputChange = (e) => {
    const value = e.target.value;
    setValue("Customer_VID", value); // update react-hook-form state

    if (debounceRef.current) clearTimeout(debounceRef.current);

    debounceRef.current = setTimeout(async () => {
      if (value.length >= 3) {
        // PartnerCaseService.GetCasePatientDetails(value, partnerInfo.userData.Partner_Code)
        PartnerCaseService.GetCasePatientDetails(value, partnerInfo?.Partner_Account_Details?.MHL_Client_Code__c)
          .then(({ data }) => {
            if (data.IsSuccess) {
              setOptions(data.Data);
              setShowDropdown(true);
            } else {
              setOptions([]);
              setShowDropdown(false);
            }
          })
          .catch(() => toast.error("Something went wrong."))
          .finally(() => { });
      } else {
        setOptions([]);
        setShowDropdown(false);
      }
    }, 300); // 300ms debounce
  };

  const handleSelect = (val) => {
    setInputValue(val.MHL_ExternalVID__c);
    setValue("Customer_VID", val.MHL_ExternalVID__c);
    setShowDropdown(false);
  };

  useEffect(() => {
    fetchPartnerComplaints();
    fetchPartner_CaseCategoryList();
  }, [])

  const fetchPartner_CaseCategoryList = () => {
    PartnerCaseService.GetPartner_CaseCategoryList()
      .then(({ data }) => {
        if (data.IsSuccess) {
          setCaseCategoryList(data.Data);
        } else {
          setCaseCategoryList([]);
        }
      })
      .catch(() => toast.error("Something went wrong."))
      .finally(() => { });
  }

  const handleCaseCategoryDD_Change = (event) => {
    const selectedOption = event.target.selectedOptions[0];
    const raisedId = selectedOption ? selectedOption.getAttribute("data-casecategoryid") : null;
    if (raisedId) {
      fetchPartner_SR_TypeList_ByCategoryId(raisedId);
    }
  }

  const fetchPartner_SR_TypeList_ByCategoryId = (categoryId) => {
    PartnerCaseService.GetPartner_SR_TypeList_ByCategoryId(categoryId)
      .then(({ data }) => {
        if (data.IsSuccess) {
          setSrTypeList(data.Data);
        } else {
          setSrTypeList([]);
        }
      })
      .catch(() => toast.error("Something went wrong."))
      .finally(() => { });
  }

  const handleSR_TypeDD_Change = (event) => {
    //debugger;
    const selectedOption = event.target.selectedOptions[0];
    const raisedId = selectedOption ? selectedOption.getAttribute("data-srtypeid") : null;
    if (raisedId) {
      fetchPartner_SR_SubTypeList_ByCategoryId(raisedId);
    }
  }

  const fetchPartner_SR_SubTypeList_ByCategoryId = (srId) => {
    PartnerCaseService.GetPartner_SR_SubTypeList_ByCategoryId(srId)
      .then(({ data }) => {
        if (data.IsSuccess) {
          setSrSubTypeList(data.Data);
        } else {
          setSrSubTypeList([]);
        }
      })
      .catch(() => toast.error("Something went wrong."))
      .finally(() => { });
  }

  const buildRequestData = (startDateValue, endDateValue) => ({
    StartDate: new Date(new Date(startDateValue).setHours(0, 0, 0, 0)).toISOString(),
    EndDate: new Date(new Date(endDateValue).setHours(23, 59, 59, 999)).toISOString(),
  });

  const fetchPartnerComplaints = () => {
    //debugger;
    setFilteredPartnerComplaintList([]);
    if (!validateDateRange(startDate, endDate)) return;

    const requestData = buildRequestData(startDate, endDate);
    requestData.Client_Code = partnerInfo?.Partner_Account_Details?.MHL_Client_Code__c;

    setSearchLoading(true);
    setLoading(true);

    PartnerCaseService.PartnerCaseList_Filter(requestData)
      .then(({ data }) => {
        if (data.IsSuccess) {
          setFilteredPartnerComplaintList(data.Data);
        } else {
          setFilteredPartnerComplaintList([]);
        }
      })
      .catch(() => toast.error("Something went wrong."))
      .finally(() => {
        setLoading(false);
        setSearchLoading(false);
      });
  };

  const validateDateRange = (startDateValue, endDateValue) => {
    if (!startDateValue || !endDateValue) {
      toast.error("Please select a date range");
      return false;
    }
    if (startDateValue > endDateValue) {
      toast.error("Start date cannot be after end date");
      return false;
    }
    if (endDateValue > new Date()) {
      toast.error("End date cannot be in the future");
      return false;
    }
    return true;
  };

  const handleRemoveIndividualFile = (fileToRemove) => {
    setSelectedFiles(prevFiles =>
      prevFiles.filter(file =>
        !(file.name === fileToRemove.name && file.size === fileToRemove.size)
      )
    );

    // Also remove from uploaded attachment list if it exists there
    setUploadedFileAttachmentList(prevList =>
      prevList.filter(file =>
        !(file.name === fileToRemove.name && file.size === fileToRemove.size)
      )
    );

    // Clear the file input to reset it
    if (fileInputRef.current) {
      fileInputRef.current.value = null;
    }
  }

  const fetchUniversalFilterCaseData = () => {
    if (selectedSearchCN.current.value == null || selectedSearchCN.current.value == "") {
      window.location.reload();
      return;
    }
    setLoading(true);
    PartnerCaseService.GetUniversalFilterPartnerCaseData(selectedSearchCN.current.value)
      .then(({ data }) => {
        if (data.IsSuccess) {
          setFilteredPartnerComplaintList(data.Data);
        }
        else (
          setFilteredPartnerComplaintList([])
        )
      })
      .catch(() => toast.error("Something went wrong."))
      .finally(() => setLoading(false));
  };

  // const handleComplaintTypeClose = () => {
  //   setSelectedComplaintType("");
  //   setSelectedComplaintTypeID("");
  //   setComplaintTypeShow(false)
  //   setShowRaiseComplaintModal(false)
  // };

  // const handleProceed = () => {
  //   if (!selectedComplaintType) {
  //     toast.error("Please select a complaint type.");
  //     return;
  //   }
  //   // setComplaintTypeShow(false)
  //   // setCaseCreationModalShow(true)
  // };

  // const onSubmit = (data) => {
  //   setLoading(true);
  //   if (activeTab === "caseInfo") {
  //     setActiveTab("case_description")
  //     setLoading(false);
  //   }
  //   else if (activeTab === "case_description") {
  //     setActiveTab("upload_attachment")
  //     setLoading(false);
  //   }
  //   else {
  //     if (selectedFiles.length != UploadedFileAttachmentList.length) {
  //       alert("Please upload selected files first.")
  //       setLoading(false);
  //       return;
  //     }

  //     data.UploadedFileAttachmentList = UploadedFileAttachmentList;
  //     PartnerCaseService.CreatePartnerCase(data)
  //       .then(({ data }) => {
  //         if (data.IsSuccess) {
  //           fetchPartnerComplaints();
  //           setEndDate(new Date());
  //           // window.location.reload();
  //           setSelectedComplaintType("");
  //           setSelectedComplaintTypeID("");
  //           toast.success(data.Data + " - Complaint created successfully")
  //           handleModalClose();
  //           setActiveTab("caseInfo");
  //         } else {
  //           toast.error("Something went wrong.")
  //           setActiveTab("caseInfo");
  //         }
  //       }).catch(() =>
  //         toast.error("Something went wrong.")
  //       ).finally(() =>
  //         setLoading(false)
  //       );
  //   }
  // };

  const handleRaiseComplaint = () => {
    setShowRaiseComplaintModal(true)
  }

  const getAllCaseRecordTypeList = () => {
    setSelectedComplaintType(null);
    PartnerCaseService.GetCaseRecordTypeList().then(({ data }) => {
      if (data.IsSuccess) {
        setCaseRecordTypeDetialList(data.Data);
        setComplaintTypeShow(true);
      } else {
        setCaseRecordTypeDetialList([])
      }
    })
      .catch(() =>
        toast.error("Something went wrong.")
      ).finally(() =>
        setLoading(false)
      );
  };

  // const handleModalClose = () => {
  //   reset();
  //   // setCaseCreationModalShow(false);
  //   setShowRaiseComplaintModal(false);
  //   setActiveTab("caseInfo");
  //   setSelectedFiles([])
  // }

  // const handlePrevious = () => {
  //   if (activeTab === "case_description") {
  //     setActiveTab("caseInfo")
  //   }
  //   else if (activeTab === "upload_attachment") {
  //     setActiveTab("case_description")
  //   }
  //   else {
  //     setComplaintTypeShow(true);
  //     setCaseCreationModalShow(false);
  //   }
  // }

  // const renderTabContent = () => {
  //   switch (activeTab) {
  //     case 'caseInfo':
  //       return (
  //         <div className="container">
  //           <div className="row g-3">
  //             {/* First Row */}
  //             <div className="col-md-6">
  //               <div className="col-md-12">
  //                 <div className="mb-3">
  //                   <div className="d-flex align-items-center gap-2">
  //                     <div style={{ width: '80px' }}>
  //                       <strong style={{ width: '120px' }}>Name</strong>
  //                     </div>
  //                     <div >

  //                       <span className="case-infodata">: {partnerInfo?.Partner_Account_Details?.Name}</span>
  //                     </div>
  //                   </div>
  //                   <input type="hidden" {...register("Customer_Name")} value={partnerInfo?.Partner_Account_Details?.Name} />
  //                   <input type="hidden" {...register("AD_ID__c")} value={partnerInfo?.Partner_Account_Details?.AD_ID__c} />
  //                   <input type="hidden" {...register("Id")} value={partnerInfo?.Partner_Account_Details?.Id} />
  //                   <input type="hidden" {...register("RecordTypeId")} value={selectedComplaintTypeID} />
  //                 </div>
  //               </div>

  //               <div className="col-md-12">
  //                 <div className="mb-3">
  //                   <div className="d-flex align-items-center gap-2">
  //                     <div style={{ width: '80px' }}>
  //                       <strong>Client Code</strong>
  //                     </div>
  //                     <div>
  //                       <span>: {partnerInfo?.Partner_Account_Details?.MHL_Client_Code__c}</span>
  //                     </div>
  //                   </div>
  //                 </div>
  //                 <input type="hidden" {...register("Client_Code")} value={partnerInfo?.Partner_Account_Details?.MHL_Client_Code__c} />
  //               </div>

  //               <div className="col-md-12">
  //                 <div className="mb-3">
  //                   <div className="d-flex align-items-center gap-2">
  //                     <div style={{ width: '80px' }}>
  //                       <strong>Mobile</strong>
  //                     </div>
  //                     <div>
  //                       <span>: {partnerInfo?.Partner_Account_Details?.MHL_Mobile_Number__c}</span>
  //                     </div>
  //                   </div>
  //                   <input type="hidden" {...register("Customer_Mobile")} value={partnerInfo?.Partner_Account_Details?.MHL_Mobile_Number__c} />
  //                 </div>
  //               </div>

  //               {/* Second Row */}

  //               <div className="col-md-12">
  //                 <div className="mb-3">
  //                   <div className="d-flex align-items-center gap-2">
  //                     <div style={{ width: '80px' }}>
  //                       <strong>Email</strong>
  //                     </div>
  //                     <div>
  //                       <span>: {partnerInfo?.Partner_Account_Details?.MHL_Email__c}</span>
  //                     </div>
  //                   </div>
  //                   <input type="hidden" {...register("Customer_Email")} value={partnerInfo?.Partner_Account_Details?.MHL_Email__c} />
  //                 </div>
  //               </div>

  //               <div className="col-md-12">
  //                 <div className="mb-3">
  //                   <div className="d-flex align-items-center gap-2">
  //                     <div style={{ width: '80px' }}>
  //                       <strong>Location</strong>
  //                     </div>
  //                     <div>
  //                       <span>: {partnerInfo?.Partner_Account_Details?.BillingCity}</span>
  //                     </div>
  //                   </div>
  //                   <input type="hidden" {...register("Locations")} value={partnerInfo?.Partner_Account_Details?.BillingCity} />
  //                 </div>
  //               </div>
  //             </div>

  //             <div className="col-md-6">

  //               <div className="col-md-12">
  //                 <div className="mb-3">
  //                   <div style={{ fontSize: '14px' }}><strong>Select an Option: </strong></div>
  //                   <div className="mt-1 d-flex flex-column">
  //                     <div className="d-flex align-items-start flex-column">
  //                       <div className="form-check form-check-inline d-flex align-items-center">
  //                         <input
  //                           className="form-check-input"
  //                           type="radio"
  //                           id="patientLevel"
  //                           value="patient"
  //                           {...register("level", { required: "Level is required" })}
  //                           style={{border: '1px solid'}}
  //                         />
  //                         <label className="form-check-label ms-1" htmlFor="patientLevel">
  //                           Patient Level
  //                         </label>
  //                       </div>

  //                       <div className="form-check form-check-inline d-flex align-items-center">
  //                         <input
  //                           className="form-check-input"
  //                           type="radio"
  //                           id="clientLevel"
  //                           value="client"
  //                           {...register("level")}
  //                           style={{border: '1px solid'}}
  //                         />
  //                         <label className="form-check-label ms-1" htmlFor="clientLevel">
  //                           Client Level
  //                         </label>
  //                       </div>
  //                     </div>

  //                     {errors.level && (
  //                       <div className="text-danger ms-1">
  //                         {errors.level.message}
  //                       </div>
  //                     )}
  //                   </div>
  //                 </div>
  //               </div>

  //               {/* Third Row - VID field spans full width or partial width */}
  //               {level === "patient" && (
  //                 <div className="col-md-12 custom-vid-field">
  //                   <div className="mb-3" style={{ position: "relative" }}>
  //                     <div style={{ fontSize: "14px" }}>
  //                       <span className="text-danger">*</span> <b> VID</b>
  //                     </div>
  //                     <input
  //                       type="text"
  //                       className="form-control mt-1"
  //                       placeholder="Enter VID"
  //                       {...register("Customer_VID", {
  //                         // required: "Customer VID is required",
  //                         required: level === 'patient' ? "Customer VID is required" : false,
  //                         maxLength: { value: 18, message: "Maximum 18 characters allowed" },
  //                         minLength: { value: 15, message: "Minimum 15 characters allowed" },
  //                       })}
  //                       onChange={handleInputChange}
  //                     />
  //                     {showDropdown && options.length > 0 && (
  //                       <ul className="list-group position-absolute w-100"
  //                         style={{
  //                           zIndex: 1000,
  //                           maxHeight: "200px",
  //                           overflowY: "auto",
  //                           boxShadow: "0 4px 8px rgba(0,0,0,0.1)"
  //                         }}
  //                       >
  //                         {options.map((opt, index) => (
  //                           <li
  //                             key={index}
  //                             className="list-group-item list-group-item-action"
  //                             onClick={() => handleSelect(opt)}
  //                             style={{ cursor: "pointer" }}
  //                           >
  //                             {opt.MHL_ExternalVID__c}
  //                           </li>
  //                         ))}
  //                       </ul>
  //                     )}
  //                     {errors.Customer_VID && <span className="text-danger">{errors.Customer_VID.message}</span>}
  //                   </div>
  //                 </div>
  //               )}
  //             </div>
  //           </div>
  //         </div>
  //       );
  //     case 'case_description':
  //       return (
  //         <div className="container pl-2">
  //           {/* Row 1 */}
  //           <div className="row mb-3">
  //             <div className="col-md-6">
  //               <label className="form-label fw-bold required">Case Raised For</label>
  //               <div className="case-select-wrapper">
  //                 <select className="form-select case-dropdown" defaultValue={""} {...register("Case_Raised_Against", { required: "Case Raised For is required" })} onChange={handleCaseCategoryDD_Change}>
  //                   <option value="">Select Case Raised for</option>
  //                   {caseCategoryList.map((item) => (
  //                     <option key={item.Id} value={item.CaseCategory} data-casecategoryid={item.Id}>
  //                       {item.CaseCategory}
  //                     </option>
  //                   ))}
  //                 </select>
  //                 {errors.Case_Raised_Against && (<p className="text-danger required_error"> {errors.Case_Raised_Against.message} </p>)}
  //               </div>
  //             </div>
  //             <div className="col-md-6">
  //               <label className="form-label fw-bold required">SR Type</label>
  //               <div className="case-select-wrapper">
  //                 <select className="form-select case-dropdown" defaultValue={""} {...register("SR_Type", { required: "SR Type is required" })} onChange={handleSR_TypeDD_Change}>
  //                   <option value="">Select SR Type</option>
  //                   {srTypeList.map((item) => (
  //                     <option key={item.SrId} value={item.TypeName} data-srtypeid={item.SrId}>{item.TypeName}</option>
  //                   ))}
  //                 </select>
  //                 {errors.SR_Type && (<p className="text-danger required_error">{errors.SR_Type.message}</p>)}
  //               </div>
  //             </div>
  //           </div>

  //           {/* Row 2 */}
  //           <div className="row mb-3">
  //             <div className="col-md-6">
  //               <label className="form-label fw-bold required">SR Sub Type</label>
  //               <div className="case-select-wrapper">
  //                 <select className="form-select case-dropdown" {...register("SR_SubType", { required: "SR Type is required" })}>
  //                   <option value="">Select SR Sub Type</option>
  //                   {srSubTypeList.map((item) => (
  //                     <option key={item.SrSubTypeId} value={item.SubTypeName} data-edit-srtypeid={item.SrSubTypeId}>{item.SubTypeName}</option>
  //                   ))}
  //                 </select>
  //                 {errors.SR_SubType && (<p className="text-danger required_error">{errors.SR_SubType.message}</p>)}
  //               </div>
  //             </div>
  //             <div className="col-md-6">
  //               <label className="form-label fw-bold required">Description</label>
  //               <textarea
  //                 className="form-control"
  //                 rows="3"
  //                 placeholder="Enter a description for the case"
  //                 {...register("Description", { required: "Description is required" })}
  //               ></textarea>
  //               {errors.Description && (<p className="text-danger required_error">{errors.Description.message}</p>)}
  //             </div>
  //           </div>
  //         </div>
  //       );
  //     case 'upload_attachment':
  //       return (
  //         <div className="container" style={{ fontSize: "13px" }}>
  //           <div className="d-flex align-items-center gap-2 mb-2 pl-3" style={{ fontSize: "13px" }} >
  //             <label className="fw-bold mb-0-5">Upload Attachments</label>
  //             <input className="form-control" style={{ width: '250px' }} type="file"
  //               ref={fileInputRef}
  //               accept=".pdf,.doc,.docx,.jpeg,.jpg,.png,.gif,.webp,.bmp,.svg,.eml"
  //               onChange={handleFileChange}
  //             />
  //             <button className="btn custom-sumbitbtn" disabled={loading} type="button" onClick={handleFileUpload}> Upload </button>
  //             <div className="alert alert-info p-2 mt-1 pt-2" style={{ fontSize: '9px', maxWidth: '350px', marginBottom: '4px', marginRight: '15px' }}>
  //               <strong>Note:</strong> You can upload a maximum of 5 files(less than 5MB).<br />
  //               Accepted files: <code>.pdf</code>, <code>.doc</code>, <code>.docx</code>, <code>.jpeg</code>, <code>.jpg</code>, <code>.png</code>, <code>.gif</code>, <code>.webp</code>, <code>.bmp</code>, <code>.svg</code>, <code>.eml</code>
  //             </div>
  //           </div>

  //           <ul className="list-group pl-3 pb-2 pt-1 col-md-6" >
  //             {selectedFiles && selectedFiles.length > 0 ? (
  //               selectedFiles.map((file) => (
  //                 <li key={file.ContentDocumentId}
  //                   className="list-group-item d-flex align-items-center justify-content-between"
  //                 >
  //                   <div>
  //                     {FileIcons[file.name.split('.').pop()] || FileIcons.other}
  //                     &nbsp;<span>{file.name}</span>
  //                   </div>
  //                   {/* <button type="button" disabled={loading} className="btn-close" onClick={() => handleRemoveIndividualFile(file)}></button> */}
  //                   <FaRegTrashAlt disabled={loading} style={{ color: 'red', cursor:'pointer' }} onClick={() => handleRemoveIndividualFile(file)} />
  //                 </li>
  //               ))
  //             ) : (
  //               null
  //             )}
  //           </ul>
  //         </div>
  //       );
  //     default:
  //       return null;
  //   }
  // };

  //Code histroy/details functions

  const toggleSection = (section) => {
    setExpandedSections((prev) => ({ ...prev, [section]: !prev[section] }));
  };

  const handleCloseCaseDetail = () => {
    setLoading(true);
    // resetEditCase();
    setCaseViewActiveTab("caseDetails");
    setSelectedCase({});
    setCaseDetailModal(false);
    setLoading(false);
  };

  const GetAttachmentsByCaseId = (caseId) => {
    setLoading(true);
    PartnerCaseService.GetPartnerCaseAttachments(caseId).then(({ data }) => {
      if (data.IsSuccess) {
        setcaseAttachmentDetails(data.Data);
      } else {
        setcaseAttachmentDetails([])
      }
    })
      .catch(() =>
        toast.error("Something went wrong.")
      ).finally(() =>
        setLoading(false)
      );
  };

  const GetCaseCommentByCaseId = (caseId) => {
    PartnerCaseService.GetPartnerCaseComments(caseId).then(({ data }) => {
      if (data.IsSuccess) {
        setcaseCommentDetails(data.Data);
      }
      else {
      }
    })
      .catch(() =>
        toast.error("Something went wrong.")
      ).finally(() =>
        setLoading(false)
      );
  };

  const handleViewCaseDetailByNo = (caseNo) => {
    //debugger;
    setLoading(true);
    setSelectedCase({});
    setCaseLocationDetailsList([]);
    setCaseStageDetailsList([]);
    setCaseSRTypeDetailsList([]);
    setCaseSRSubTypeDetailsList([]);
    PartnerCaseService.GetPartnerCaseDetailByCaseNumber(caseNo).then(({ data }) => {
      if (data.IsSuccess) {
        //debugger;
        if (data.Data.CaseData.MHL_SR_Type__c == "Refund") {

        }
        setSelectedComplaintTypeID(data.Data.CaseData.RecordTypeId);
        setSelectedCase(data.Data.CaseData);
        setCaseLocationDetailsList(data.Data.CaseLocationData);
        setCaseStageDetailsList(data.Data.CaseStageData);
        setCaseSRTypeDetailsList(data.Data.CaseSRTypeData);
        setCaseSRSubTypeDetailsList(data.Data.CaseSRSubTypeData);
        setCaseCategoryDetailsList(data.Data.CaseCategoryData);
        // handlecaseeditevents(data.Data);
        setCaseDetailModal(true);
      } else {
        setSelectedCase({})
        // toast.error("No Data found for selected range");
      }
    })
      .catch(() =>
        toast.error("Something went wrong.")
      ).finally(() =>
        setLoading(false)
      );
  };

  const GetCaseHistoryByCaseId = (caseId) => {
    setLoading(true);
    PartnerCaseService.GetPartnerCaseHistory(caseId).then(({ data }) => {
      if (data.IsSuccess) {
        //debugger;
        setcaseHistoryDetails(data.Data);
      }
      else {
      }
    })
      .catch(() =>
        toast.error("Something went wrong.")
      ).finally(() =>
        setLoading(false)
      );
  };

  const handleDownloadAttachment = async (file) => {
    //debugger;

    setLoading(true);  // Start loading
    const downloadUrl = API_DOMAIN + `PartnerCase/PartnerDownloadAttachments?url=${file.VersionData}&filename=${file.Title}&ext=${file.FileExtension}`;

    try {
      const response = await trackPromise(
        axios.get(downloadUrl, {
          headers: API_HEADER,  // Add your headers here
          responseType: 'blob',                 // Important for files
        })
      );

      const blob = new Blob([response.data]);
      saveAs(blob, file.Title + '.' + file.FileExtension);
    } catch (error) {
      console.error('Download failed:', error);
    }

    setLoading(false);
  };

  return (
    <CommonContainer
      icon={<FaComments size={20} />}
      heading="Partner Complaints"
      buttonText={
        accessToRaiseComplaintRights && (
          <span className="d-inline-flex align-items-center">
            <span className="d-none d-sm-inline">Raise Complaint</span>
          </span>
        )
      }
      onButtonClick={() => {
        if (accessToRaiseComplaintRights) {
          handleRaiseComplaint();
        }
      }}
    >
      <div className="d-flex flex-column flex-lg-row align-items-lg-center justify-content-between mb-2 custom-date-range gap-2">
        <div className="d-flex align-items-center gap-2 custom-date-range">
          <select
            className="form-select date-range-select"
            style={{}}
            value={dateRangeOption}
            onChange={handleDateRangeChange}
          >
            <option value="Today">Today</option>
            <option value="Yesterday">Yesterday</option>
            <option value="Current Week">Current Week</option>
            <option value="Last 7 Days">Last 7 Days</option>
            <option value="MTD">MTD</option>
            <option value="Last 30 Days">Last 30 Days</option>
            <option value="Custom">Custom</option>
          </select>


          {(dateRangeOption === "Custom") && (
            <>
              <div className="position-relative custom-date-picker">
                <ReactDatePicker
                  selected={startDate}
                  onChange={(date) => setStartDate(date)}
                  className="form-control"
                  dateFormat="dd-MM-yyyy"
                  placeholderText="Select Start Date"
                  ref={startDateRef}
                />
                <Calendar
                  size={20}
                  className="position-absolute"
                  style={{ right: "10px", top: "50%", transform: "translateY(-50%)" }}
                  onClick={() => startDateRef.current.setFocus()}
                />
              </div>

              <div className="position-relative custom-date-picker">
                <ReactDatePicker
                  selected={endDate}
                  onChange={(date) => setEndDate(date)}
                  className="form-control"
                  dateFormat="dd-MM-yyyy"
                  placeholderText="Select End Date"
                  ref={endDateRef}
                />
                <Calendar
                  size={20} className="position-absolute"
                  style={{ right: "10px", top: "50%", transform: "translateY(-50%)" }}
                  onClick={() => endDateRef.current.setFocus()}
                />
              </div>
            </>
          )}


          <button
            className="btn custom-sumbitbtn partner-case-go-btn d-flex align-items-center justify-content-center p-1 "
            style={{ height: "35px", padding: "0" }}
            onClick={fetchPartnerComplaints}
            disabled={loading}
          >
            {loading ? <FaSpinner className="fa-spin" /> : <b>GO</b>}
          </button>

          {SearchLoading ?
            <LoadingMessage />
            : null}
        </div>

        <div className="search-box" style={{ position: "relative", width: "100%" }}>
          <input
            type="text"
            className="form-control"
            placeholder="Search by Case Number, Contact Name"
            ref={selectedSearchCN}
            style={{
              paddingRight: "35px",
              borderRadius: "5px",
              border: "1px solid #ddd",
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                fetchUniversalFilterCaseData();
              }
            }}
          />
          <button
            className="btn custom-sumbitbtn d-flex align-items-center justify-content-center"
            style={{
              padding: '5px',
              position: "absolute",
              right: "0px",
              height: "35px",
              width: "45px",
              top: "50%",
              borderTopLeftRadius: "0",
              borderBottomLeftRadius: "0",
              transform: "translateY(-50%)"
            }}
            onClick={fetchUniversalFilterCaseData}
            disabled={loading}
          >
            <FaSearch />
          </button>
        </div>
      </div>
      <div>
        <div className="table-responsive" >
          <table className="table table-bordered custom-table" >
            <thead>
              <tr >
                {/* <th> S. No </th> */}
                <th style={{ width: "10%" }}> Case Number </th>
                <th style={{ width: "13%" }}> Contact Name </th>
                <th style={{ width: "6%" }}> Status </th>
                <th style={{ width: "10%" }}> Record Type </th>
                <th style={{ width: "10%" }}> SR Type </th>
                <th style={{ width: "24%" }}> SR Sub Type </th>
                <th style={{ width: "14%" }}> Created Date/Time </th>
                <th style={{ width: "13%" }}> Closed Date/Time </th>
              </tr>
            </thead>
            <tbody>
              {
                currentList.length > 0 ? (
                  currentList.map((rec, index) => (
                    <tr key={index}>
                      {/* <td>{index + 1}</td> */}
                      {/* <td>{rec?.CaseNumber}</td> */}
                      <td>{
                        // rec.RecordType.Name === 'FTR' ? (
                        //   rec.CaseNumber
                        // ) : (
                        <span title="Click to view details" onClick={() => handleViewCaseDetailByNo(rec.CaseNumber)} className="text-primary" style={{ cursor: "pointer" }}> {rec.CaseNumber} </span>
                        // )
                      }</td>
                      <td>{rec?.External_User_Name__c != null ? rec?.External_User_Name__c : rec.CreatedBy?.Name}</td>
                      <td>{rec?.Status}</td>
                      <td>{rec?.RecordType?.Name || ''}</td>
                      <td>{rec?.MHL_SR_Type_Portal__c || ''}</td>
                      <td>{rec?.MHL_SR_Sub_Type_Portal__c || ''}</td>
                      <td>{rec?.CreatedDate ? new Date(rec.CreatedDate).toLocaleString('en-GB', {
                        day: '2-digit',
                        month: '2-digit',
                        year: 'numeric',
                        hour: '2-digit',
                        minute: '2-digit',
                        hour12: true
                      }).replace(',', '').toUpperCase() : ''}
                      </td>
                      <td>{rec.ClosedDate ? new Date(rec.ClosedDate).toLocaleString('en-GB', {
                        day: '2-digit',
                        month: '2-digit',
                        year: 'numeric',
                        hour: '2-digit',
                        minute: '2-digit',
                        hour12: true
                      }).replace(',', '').toUpperCase() : ''}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr><td colSpan="9" className="text-center">No Data found</td></tr>
                )
              }
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        {filteredPartnerComplaintList.length > itemsPerPage ? (
          <CommonPagination
            pageList={filteredPartnerComplaintList}
            currentPage={currentPage}
            itemsPerPage={itemsPerPage}
            setCurrentPage={setCurrentPage}
          />
        ) : null}
      </div>

      {/* {complaintTypeShow && (
        <div className="modal-backdrop">
          <div className="modal fade show d-block" tabIndex="-1" role="dialog">
            <div className="modal-dialog modal-sm custom-modal-com" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">New Case</h5>
                  <button type="button" disabled={loading} className="btn-close" onClick={handleComplaintTypeClose}></button>
                </div>
                <div className="modal-body">
                  <div>
                    <label className="fw-bold required mb-0-5" > Select a Record Type </label>
                    {CaseRecordTypeDetialList.map((type) => (
                      <div key={type.RecordTypeId} className="form-check">
                        <input
                          type="radio"
                          id={type.RecordTypeId}
                          className="form-check-input form-check-newcase"
                          value={type.RecordTypeId}
                          checked={selectedComplaintType === type.RecordType}
                          onChange={() => { setSelectedComplaintType(type.RecordType); setSelectedComplaintTypeID(type.RecordTypeId) }}
                        />
                        <label htmlFor={type.RecordTypeId} className="form-check-label">{type.RecordType_Label}</label>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="modal-footer">
                  <button type="button" disabled={loading} className="btn btn-danger" onClick={handleComplaintTypeClose}>Close</button>
                  <button type="button" disabled={loading} className="btn btn-primary" onClick={handleProceed}>Proceed</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {caseCreationModalShow && (
        <div className="modal-backdrop">
          <div className="modal fade show d-block" tabIndex="-1" role="dialog">
            <div className="modal-dialog modal-lg custom-modal" style={{ maxWidth: '700px'}} role="document">
              <div className="modal-content mb-0 p-0">
                <div className="modal-header p-2-5">
                  <h5 className="modal-title">New Case: {selectedComplaintType}</h5>
                  <button type="button" disabled={loading} className="btn-close" onClick={handleModalClose}></button>
                </div>
                <div className="modal-body p-0">
                  <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
                    <ul className="nav nav-tabs mb-2">
                      <li className="nav-item">
                        <button type="button" className={`tab-button-header nav-link 
                              ${activeTab === "caseInfo" ? "active highlighted-tab" : ""} `}
                          onClick={() => setActiveTab("caseInfo")}
                        // style={{ cursor: "default" }}
                        >
                          Case Information
                        </button>
                      </li>
                      <li className="nav-item">
                        <button type="button" className={`tab-button-header nav-link 
                              ${activeTab === "case_description" ? "active highlighted-tab" : ""}`}
                          onClick={() => setActiveTab("case_description")}
                        // style={{ cursor: "default" }}
                        >
                          Case Description
                        </button>
                      </li>
                      <li className="nav-item">
                        <button type="button" className={`tab-button-header  nav-link 
                              ${activeTab === "upload_attachment" ? "active highlighted-tab" : ""}`}
                          onClick={() => setActiveTab("upload_attachment")}
                        // style={{ cursor: "default" }}
                        >
                          Upload Attachments
                        </button>
                      </li>
                    </ul>
                    {renderTabContent()}
                    <div className="modal-footer mt-0 mb-0 pt-1 pb-0 pr-1">
                      <button type="button" disabled={loading} className="btn btn-secondary" onClick={handlePrevious}> Previous </button>
                      <button type="submit" disabled={loading} className="btn custom-sumbitbtn">
                        {activeTab === "upload_attachment" ? "Save" : "Save & Next"}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      )} */}

      {showRaiseComplaintModal && (
        <RaiseComplaint
          showModal={showRaiseComplaintModal}
          setShowModal={setShowRaiseComplaintModal}
          vid={""}
        />
      )}

      {caseDetailModal && selectedCase && (
        <>
          {/* <div className="case-details gap-2-container" style={{maxHeight: "500px" }} > */}
          <div className="modal-backdrop" > </div>
          < div className="modal fade show d-block " tabIndex="-1" role="dialog" >
            <div className="modal-dialog modal-lg custom-modal" role="document" >
              <div className="modal-content mb-0 p-0" style={{ minHeight: '400px' }} >

                <div className="modal-header  p-2-5" >
                  <h5 className="modal-title" > <b>Case Information </b> ({selectedCase.CaseNumber}/{selectedCase.Status}{selectedCase.MHL_Case_Stage__c ? "/" + selectedCase.MHL_Case_Stage__c : ""})</h5>
                  < button type="button" disabled={loading} className="btn-close" onClick={handleCloseCaseDetail} > </button>
                </div>

                <div className="modal-body p-1" style={{ fontSize: "14px", height: "68vh", overflowX: "hidden" }}>
                  {/* <LoadingSpinnerComponent></LoadingSpinnerComponent> */}
                  <ul className="nav nav-tabs mb-2" >
                    <li className="nav-item" >
                      <button
                        type="button"
                        className={`tab-button-header nav-link ${caseViewActiveTab === "caseDetails" ? "active highlighted-tab" : ""}`}
                        onClick={() => setCaseViewActiveTab("caseDetails")}
                      >
                        Details
                      </button>
                    </li>

                    < li className="nav-item" >
                      <button
                        type="button"
                        className={`tab-button-header nav-link ${caseViewActiveTab === "attachmentDetails" ? "active highlighted-tab" : ""}`}
                        onClick={() => {
                          GetAttachmentsByCaseId(selectedCase.Id)
                          setCaseViewActiveTab("attachmentDetails")
                        }}
                      >
                        Attachment
                      </button>
                    </li>
                    < li className="nav-item" >
                      <button
                        type="button"
                        style={{ color: "black" }}
                        className={`tab-button-header nav-link ${caseViewActiveTab === "comments" ? "active highlighted-tab" : ""}`}
                        onClick={() => {
                          GetCaseCommentByCaseId(selectedCase.Id)
                          setCaseViewActiveTab("comments");
                        }
                        }>
                        Case Comments
                      </button>
                    </li>
                    <li className="nav-item">
                      <button
                        type="button"
                        className={`tab-button-header nav-link ${caseViewActiveTab === "caseHistory" ? "active highlighted-tab" : ""}`}
                        onClick={() => {
                          GetCaseHistoryByCaseId(selectedCase.Id);
                          setCaseViewActiveTab("caseHistory");
                        }}
                      >
                        Case History
                      </button>
                    </li>
                  </ul>

                  {caseViewActiveTab === "caseDetails" && (
                    <>
                      <div className="section" >
                        <div className="section-header" style={{ background: "#01994e", color: "#fff" }}  >
                          <span>Case Details </span>
                          < i className={`toggle-icon d-flex`
                          } onClick={() => toggleSection("caseDetails")}>
                            {expandedSections.caseDetails ? <FaMinusSquare /> : <FaPlusSquare />}
                          </i>
                        </div>
                        {
                          expandedSections.caseDetails && (
                            // <form onSubmit={handleEditCaseSubmit(UpdateCaseDetail)}>
                            <form onSubmit={""}>
                              <div className="section-content" style={{ fontSize: "13px" }}>
                                <div className="row">
                                  <div className="col-md-6">
                                    <p className="case-details gap-2">
                                      <strong>Case Origin:</strong> <span>{selectedCase.Origin}</span>
                                      {/* <input type="hidden" {...registerEditCase("Id")} value={selectedCase.Id} /> */}
                                      {/* <input type="hidden" {...registerEditCase("CaseNumber")} value={selectedCase.CaseNumber} /> */}
                                    </p>
                                    <p className="case-details gap-2">
                                      {/* <input type="hidden" {...registerEditCase("MHL_Call_Type__c")} value={selectedCase.MHL_Call_Type__c} />
                                        <input type="hidden" {...registerEditCase("RecordTypeId")} value={selectedCase.RecordTypeId} /> */}
                                      <strong>Call Type:</strong> <span>{selectedCase.MHL_Call_Type__c}</span>
                                    </p>

                                    <p className="case-details gap-2">
                                      <strong>Call Raised For:</strong> <span>{selectedCase.MHL_Case_Raised_For__c}</span>
                                    </p>
                                    {/* <div className="case-selection">
                                        <label className="case-label"><strong>SR Location:</strong></label>
                                        <div className="case-select-wrapper">
                                          <select className="form-select case-dropdown" defaultValue={selectedCase?.MHL_Location__c || ""} {...registerEditCase("MHL_Location__c", { required: "Location is required" })}>
                                            <option className="dropdown-option" value="">Select Location</option>
                                            {CaseLocationDetailsList.map((item) => (
                                              <option className="dropdown-option" key={item.CaseLocation_Id} value={item.LocationName}>{item.LocationName}</option>
                                            ))}
                                          </select>
                                          {errorEditCase.MHL_Location__c && (<p className="text-danger required_error">{errorEditCase.MHL_Location__c.message}</p>)}
                                        </div>
                                      </div> */}

                                    <p className="case-details gap-2">
                                      <strong>Department:</strong> <span>{selectedCase.MHL_Department__c}</span>
                                    </p>
                                    <p className="case-details gap-2">
                                      <strong>Subject:</strong> <span>{selectedCase.Subject}</span>
                                    </p>
                                    <p className="case-details gap-2 align-items-start">
                                      <strong>Description:</strong>
                                      {selectedCase.Description && (
                                        <span>
                                          {showFullDescription ? selectedCase.Description : `${selectedCase.Description.slice(0, 70)}...`}
                                          {selectedCase.Description.length > 70 && (
                                            <span
                                              onClick={() => setShowFullDescription(!showFullDescription)}
                                              style={{ fontSize: "12px", color: "blue", cursor: "pointer", textDecoration: "underline" }}
                                            >
                                              {showFullDescription ? "See less" : "See more"}
                                            </span>
                                          )}
                                        </span>
                                      )}
                                    </p>
                                  </div>
                                  <div className="col-md-6 ps-md-4 divider-left">
                                    <p className="case-details gap-2">
                                      <strong>Case Owner:</strong> <span>{selectedCase.Owner.Name}</span>
                                    </p>
                                    <p className="case-details gap-2">
                                      <strong>Record Type:</strong> <span>{selectedCase.RecordType.Name}</span>
                                    </p>
                                    <div className="case-selection">
                                      <p className="case-details gap-2">
                                        <strong>SR Type:</strong> <span>{selectedCase.MHL_SR_Type_Portal__c}</span>
                                      </p>
                                    </div>

                                    <div className="case-selection">
                                      <p className="case-details gap-2">
                                        <strong>SR Sub Type:</strong> <span>{selectedCase.MHL_SR_Sub_Type_Portal__c}</span>
                                      </p>
                                    </div>

                                    {/* <div className="case-selection">
                                        <label className="case-label"><strong>Case Stage:</strong></label>
                                        <div className="case-select-wrapper">
                                          <select className="form-select case-dropdown" defaultValue={selectedCase?.MHL_Case_Stage__c || ""} {...registerEditCase("MHL_Case_Stage__c")}>
                                            <option className="dropdown-option" value="">Select Case Stage</option>
                                            {CaseStageDetailsList.map((item) => (
                                              <option className="dropdown-option" key={item.CaseStage_Id} value={item.CaseStage}>{item.CaseStage}</option>
                                            ))}
                                          </select>
                                        </div>
                                      </div> */}

                                    <p className="case-details gap-2">
                                      <strong>Test Name:</strong> <span>{selectedCase.External_Test_Name__c}</span>
                                    </p>
                                    <p className="case-details gap-2">
                                      <strong>Type Of Case:</strong> <span>{selectedCase.MHL_Type_of_Case__c}</span>
                                    </p>
                                    <p className="case-details gap-2">
                                      <strong>Country:</strong> <span>{selectedCase.MHL_Country__c}</span>
                                    </p>
                                  </div>
                                </div>
                                {/* {selectedCase.Status === "Open" && (
                                    <div style={{ textAlign: "right" }}>
                                      <button type="submit" disabled={loading} className="btn btn-primary">Update Case</button>
                                    </div>
                                  )} */}
                                {/* <button type="submit" className="btn btn-primary">Update</button> */}
                              </div>
                            </form>
                          )}
                      </div>

                      {/* Customer Details Section */}
                      <div className="section" style={{ fontSize: "13px" }} >
                        <div className="section-header" style={{ background: "#01994e", color: "#fff" }} >
                          <span>Customer Details </span>
                          < i className={`toggle-icon d-flex`} onClick={() => toggleSection("customerDetails")}>
                            {expandedSections.customerDetails ? <FaMinusSquare /> : <FaPlusSquare />}
                          </i>
                        </div>
                        {
                          expandedSections.customerDetails && (
                            <div className="section-content" >
                              <div className="row" >
                                <div className="col-md-6" >
                                  <p className="case-details"><strong>Customer PID: </strong> {selectedCase.MHL_Customer_PID__c}</p >
                                  <p className="case-details"><strong>Customer VID: </strong> {selectedCase.MHL_VID_Portal__c}</p >
                                  <p className="case-details"><strong>Location: </strong> {selectedCase.MHL_Locations__c}</p >
                                </div>
                                < div className="col-md-6 ps-md-4 divider-left" >
                                  <p className="case-details gap-2"><strong>Customer Name: </strong> {selectedCase.MHL_Customer_Name__c}</p >
                                  <p className="case-details gap-2"><strong>Customer Email: </strong> {selectedCase.MHL_Customer_Email__c}</p >
                                  <p className="case-details gap-2"><strong>Customer Mobile: </strong>{selectedCase.MHL_Customer_Mobile__c}</p >
                                </div>
                              </div>
                            </div>
                          )
                        }
                      </div>

                      {/* Status Section */}
                      <div className="section" style={{ fontSize: "13px" }} >
                        <div className="section-header" style={{ background: "#01994e", color: "#fff" }}  >
                          <span>Status </span>
                          < i className={`toggle-icon d-flex`} onClick={() => toggleSection("status")}>
                            {expandedSections.status ? <FaMinusSquare /> : <FaPlusSquare />}
                          </i>
                        </div>
                        {
                          expandedSections.status && (
                            <div className="section-content" >
                              <div className="row" >
                                <div className="col-md-6" >
                                  <p className="case-details gap-2"><strong>Status: </strong> {selectedCase.Status}</p >
                                  <p className="case-details gap-2"><strong>Cancellation Reason: </strong> {selectedCase.MHL_Cancellation_Reason__c}</p >
                                  <p className="case-details gap-2"><strong>Case Age Diff: </strong> {selectedCase.MHL_caseAgeDiff__c}</p >
                                </div>
                                < div className="col-md-6 ps-md-4 divider-left" >
                                  <p className="case-details gap-2"><strong>Priority: </strong> {selectedCase.Priority}</p >

                                  <p className="case-details gap-2"><strong>Date / Time Opened: </strong> {moment(selectedCase.CreatedDate).format("DD-MMM-YYYY hh:mm A")}</p >
                                  <p className="case-details gap-2">
                                    <strong>Date / Time Closed: </strong>
                                    {selectedCase.MHL_Closed_Date_Time__c ? moment(selectedCase.MHL_Closed_Date_Time__c).format("DD-MMM-YYYY hh:mm A") : "NA"}
                                  </p>                                    </div>
                              </div>
                            </div>
                          )
                        }
                      </div>

                      {/* Action Taken Section */}
                      <div className="section" style={{ fontSize: "13px" }} >
                        <div className="section-header" style={{ background: "#01994e", color: "#fff" }}  >
                          <span>Action Taken </span>
                          < i className={`toggle-icon d-flex`} onClick={() => toggleSection("actionTaken")}>
                            {expandedSections.actionTaken ? <FaMinusSquare /> : <FaPlusSquare />}
                          </i>
                        </div>
                        {
                          expandedSections.actionTaken && (
                            <div className="section-content" >
                              <div className="row" >
                                <div className="col-md-6" >
                                  <p className="case-details gap-2"><strong>Resolutions: </strong> {selectedCase.MHL_Resolutions__c}</p>
                                  <p className="case-details gap-2"><strong>Resolution Channel: </strong> {selectedCase.MHL_Resolution_Channel__c}</p>
                                </div>
                                < div className="col-md-6 ps-md-4 divider-left" >
                                  <p className="case-details gap-2"><strong>Internal Comments: </strong> {selectedCase.Comments}</p>
                                  <p className="case-details gap-2"><strong>Staff Responsible: </strong> {selectedCase.MHL_Staff_Responsible__c}</p>
                                </div>
                              </div>
                            </div>
                          )
                        }
                      </div>
                    </>
                  )}

                  {caseViewActiveTab === "o2cDetails" && (
                    <div className="container" style={{ fontSize: "13px" }}>
                      {/* <h5><b>O2C Details</b></h5> */}
                      <div className="row" >
                        <div className="col-md-6">
                          <p className="case-details gap-2"><strong>Payment Received:</strong> INR {selectedCase.MHL_PaymentReceived__c}</p>
                          <p className="case-details gap-2"><strong>Payment Received Amount:</strong> INR {selectedCase.MHL_PaymentReceivedAmount__c}</p>
                          <p className="case-details gap-2"><strong>Amount To Be Refunded:</strong> INR {selectedCase.MHL_Amount_To_Be_Refunded__c}</p>
                        </div>
                        <div className="col-md-6">
                          {/* <p className="case-details gap-2"><strong>Payment Received Date:</strong> {moment(selectedCase.MHL_Payment_Received_Date__c).format("DD-MMM-YYYY hh:mm A")}</p> */}
                          <p className="case-details gap-2">
                            <strong>Payment Received Date: </strong>
                            {selectedCase.MHL_Payment_Received_Date__c ? moment(selectedCase.MHL_Payment_Received_Date__c).format("DD-MMM-YYYY hh:mm A") : "NA"}
                          </p>
                          {/* <p className="case-details gap-2"><strong>Payment Received Date:</strong> {moment(selectedCase.MHL_Payment_Received_Date__c).format("DD-MMM-YYYY hh:mm A")}</p> */}
                          <p className="case-details gap-2"><strong>Payment Mode:</strong> {selectedCase.MHL_PaymentMode__c}</p>
                          <p className="case-details gap-2"><strong>CC Avenue No./Payment Reference No. :</strong>  {selectedCase.MHL_CC_Avenue_No_Payment_Reference_No__c}</p>
                        </div>
                      </div>
                    </div>
                  )}

                  {
                    caseViewActiveTab === "attachmentDetails" && (
                      <div className="p-2">
                        <div className="container" >
                          <ul className="list-group" >
                            {caseAttachmentDetails && caseAttachmentDetails.length > 0 ? (
                              caseAttachmentDetails.map((file) => (
                                <li key={file.ContentDocumentId} className="list-group-item d-flex align-items-center" >
                                  {FileIcons[file.FileExtension] || FileIcons.other}
                                  {file.Title}
                                  < span className="badge ms-auto p-2 rounded" >
                                    <FaDownload disabled={loading} onClick={() => handleDownloadAttachment(file)} style={{ color: 'green', fontSize: '18px', cursor: 'pointer' }} />
                                  </span>

                                </li>
                              ))
                            ) : (
                              // <li className="list-group-item text-muted" > No attachments available </li>
                              <p> No attachments available... </p>
                            )}
                          </ul>

                        </div>
                      </div>
                    )}

                  {
                    caseViewActiveTab === "comments" && (
                      <div className="p-2">
                        <div className="table-responsive" >
                          <table className="table custom-table" >
                            <thead>
                              <tr>
                                < th className="user-column"> User </th>
                                < th className="date-column"> Created Date </th>
                                < th className="comment-column" > Comment </th>
                              </tr>
                            </thead>
                            <tbody>
                              {
                                caseCommentDetails && caseCommentDetails.length > 0 ? (
                                  caseCommentDetails.map((dt, index) => (
                                    <tr key={dt.Id || index} >
                                      < td > {dt.CreatedBy.Name} </td>
                                      < td > {moment(dt.CreatedDate).format("DD-MMM-YYYY hh:mm A")} </td>
                                      < td > {dt.CommentBody} </td>
                                    </tr>
                                  ))
                                ) : (
                                  <tr>
                                    <td colSpan="7" className="text-center" >
                                      No comments found
                                    </td>
                                  </tr>
                                )
                              }
                            </tbody>
                          </table>
                        </div>
                      </div>
                    )}

                  {caseViewActiveTab === "caseHistory" && (
                    <div className="p-2">
                      <div className="table-responsive">
                        <table className="table custom-table">
                          <thead>
                            <tr>
                              <th >Date</th>
                              <th >Field</th>
                              <th >User</th>
                              <th className="user-column">Original Value</th>
                              <th className="user-column">Old Value</th>
                            </tr>
                          </thead>
                          <tbody>
                            {caseHistoryDetails && caseHistoryDetails.length > 0 ? (
                              caseHistoryDetails.map((dt, index) => (
                                <tr key={dt.Id || index}>
                                  <td>{moment(dt.CreatedDate).format("DD-MMM-YYYY hh:mm A")}</td>
                                  <td>{dt.Field}</td>
                                  <td>{dt.CreatedBy.Name}</td>
                                  <td>{dt.NewValue}</td>
                                  <td>{dt.OldValue}</td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan="5" className="text-center">
                                  No history found
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  )}

                </div>

                < div className="modal-footer" >
                  {/* <button type="button" disabled={loading} className="btn btn-danger" onClick={handleCloseCaseDetail} >
                      Close
                    </button> */}
                </div>
              </div>
            </div>
          </div>
          {/* </div> */}

        </>
      )}
    </CommonContainer>
  )
}

export default PartnerCaseComponent